module.exports = __webpack_public_path__ + "img/2.8511fb1a.jpg";